import { clamp, Easing } from '@/lib/anim/easing';

import { T } from './storyboard';

// Ch. 06 - wordmark: the logo settles with a slow breathing drift and the
// tagline rules itself in underneath.
export function Scene6Wordmark({ time, logoSrc }: { time: number; logoSrc: string }) {
  const [start, end] = T.wordmark;
  if (time < start || time > end) return null;
  const localTime = time - start;

  const inT = Easing.easeOutCubic(clamp(localTime / 0.9, 0, 1));
  const taglineT = Easing.easeOutCubic(clamp((localTime - 0.55) / 0.7, 0, 1));
  const underlineT = clamp((localTime - 0.95) / 1, 0, 1);
  const drift = 1 + 0.015 * Easing.easeInOutSine(clamp((localTime - 0.4) / 1.6, 0, 1));

  return (
    <>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: `radial-gradient(ellipse at 50% 50%, rgba(196,152,58,${0.08 * inT}) 0%, transparent 55%)`,
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '44%',
          transform: `translate(-50%, -50%) scale(${(0.93 + 0.07 * inT) * drift})`,
          opacity: inT,
          zIndex: 2,
        }}
      >
        <img
          src={logoSrc}
          alt="ASSAY"
          style={{
            width: 880,
            height: 'auto',
            display: 'block',
            filter: `drop-shadow(0 0 40px rgba(196,152,58,${0.15 * inT}))`,
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '70%',
          transform: 'translate(-50%, -50%)',
          opacity: taglineT,
          textAlign: 'center',
          zIndex: 2,
        }}
      >
        <div
          style={{
            fontFamily: '"DM Mono", monospace',
            fontSize: 18,
            letterSpacing: '0.42em',
            textTransform: 'uppercase',
            color: 'var(--assay-text-primary)',
            marginBottom: 18,
            paddingLeft: '0.42em',
          }}
        >
          Relationships, Measured
        </div>
        <div
          style={{
            width: 320,
            margin: '0 auto',
            height: 1,
            background: 'var(--assay-ore)',
            transformOrigin: 'center',
            transform: `scaleX(${underlineT})`,
            boxShadow: '0 0 12px rgba(196,152,58,0.6)',
          }}
        />
      </div>
    </>
  );
}
